import { render, staticRenderFns } from "./ElementScaleConfigTableColumn.vue?vue&type=template&id=3cb07c4e"
import script from "./ElementScaleConfigTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementScaleConfigTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementScaleConfigTableColumn.vue?vue&type=style&index=0&id=3cb07c4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports